<script setup lang="ts">
import DeltaArrowIncrease from '../visualAssets/social/DeltaArrowIncrease.svg?component';
import DeltaArrowDecrease from '../visualAssets/social/DeltaArrowDecrease.svg?component';
import DeltaArrowNoMovement from '../visualAssets/social/DeltaArrowNoMovement.svg?component';
import { FunctionalComponent } from 'vue';

interface VisualDeltaProps {
  value: number;
  invert?: boolean;
}

const props = withDefaults(defineProps<VisualDeltaProps>(), {
  invert: false,
});

const { value, invert } = toRefs(props);
const image = computed<FunctionalComponent | null>(() => {
  if (value.value > 0) {
    return DeltaArrowIncrease;
  } else if (value.value < 0) {
    return DeltaArrowDecrease;
  } else if (value.value == 0) {
    return DeltaArrowNoMovement;
  } else {
    return null;
  }
});

const colorIndex = computed<number>(() => (invert.value ? -value.value : value.value));
const displayValue = computed<string>(() => (value.value > 0 ? '+' + value.value : value.value.toString()));
</script>

<template>
  <span
    v-if="image != null"
    class="review-delta"
    :class="{
      'review-delta-pos': colorIndex > 0,
      'review-delta-neg': colorIndex < 0,
      'review-delta-zero': colorIndex == 0,
    }"
  >
    <component class="review-delta-icon" :is="image" />
    {{ displayValue }}
  </span>
</template>
<style scoped lang="scss">
.review-delta {
  border-radius: 3px;
  color: white;
  padding: 0px 3px;
  font-size: 12px;
  white-space: nowrap;
  font-weight: 600;

  .review-delta-icon {
    margin: 4px 0px 0px 0px;
  }

  &.review-delta-pos {
    background-color: #0c8a65;
  }

  &.review-delta-neg {
    background-color: #d4002b;
  }

  &.review-delta-zero {
    background-color: #7f7466;
  }
}
</style>
